
export class Bag<T>
{
    public Items: T[] = [];

    constructor(public Name: string, public Title: string)
    { }

    public get Size(): number
    {
        return this.Items.length;
    }

    public Add(item: T)
    {
        this.Items.push(item);
    }
}
